import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RetornoSelecao } from './../../../shared/gridview/RetornoSelecao';
import { Estado } from './../../../shared/shared/estado.enum';

declare var $: any;

@Component({
  selector: 'app-previsao-compra',
  templateUrl: './previsao-compra.component.html',
  styleUrls: ['./previsao-compra.component.css']
})
export class PrevisaoCompraComponent implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;
  parametrosFiltro: any;

  filtros = {};

  constructor(private route: ActivatedRoute) { 
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.carregarFiltrosParametros();
    });
  }

  ngOnInit() {
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#previsao-compra-filtro').modal();
  }

}
